// @flow

import type {
  djangoModelApiResponse,
  wrappedApiResponseType,
} from '../apiTypes';
import type { transactionLandType } from '../../types';
import { hpfetch } from '../util';

export const getSingle = (
  transactionId: number,
  id: number,
): Promise<wrappedApiResponseType<transactionLandType>> =>
  hpfetch(`purchases/${transactionId}/lands/${id}/`);

export const getMany = (
  transactionId: number,
  limit: number = 100,
  offset: number = 0,
): djangoModelApiResponse<transactionLandType> =>
  hpfetch(`purchases/${transactionId}/lands/?limit=${limit}&offset=${offset}`);

export const update = (transactionId: number, id: number, fields: any) =>
  hpfetch(`purchases/${transactionId}/lands/${id}/`, {
    method: 'PATCH',
    body: JSON.stringify(fields),
  });
